const messages = {
  name: 'License |||| Licenses',
  fields: {
    name: 'License Name',
  },
  empty: 'No licenses yet',
  invite: 'Add your first license',
  create: {
    title: 'Create License',
  },
  edit: {
    title: 'Edit License',
  },
  dialog: {
    title: 'License Details',
  },
  sections: {
    basicInfo: 'Basic Information',
  },
  filters: {
    licenseName: 'License Name',
  },
  actions: {
    addLicense: 'Add License',
    discard: 'Discard',
    submit: 'Submit',
  },
  validation: {
    nameRequired: 'License Name is required',
    nameMaxLength: 'License Name must be at most %{max} characters',
  },
  help: {
    createBanner: 'Add a new license to your Notify account.',
    editBanner: 'Update the license details.',
    name: 'The display name for this license. Must be unique.',
  },
  delete: {
    title: 'Delete license "%{recordName}"',
    content: 'Are you sure you want to delete this license? This action cannot be undone.',
  },
  notifications: {
    created: 'License created successfully',
    updated: 'License updated successfully',
    deleted: 'License deleted successfully',
    loadFailed: 'Failed to load license',
    createFailed: 'Failed to create license',
    updateFailed: 'Failed to update license',
  },
};

export default messages;
